import React from 'react';
import {isMobile} from 'react-device-detect';
import {AbroadPackageModel, PackageDetails, PackageType, UnitMeasureCodeOptionsFeature} from '../Models/AbroadPackageModels';
import {getDataUsageDisplay} from '../../cellcomAbroadUtilities';
import '../Sass/AbroadDifferentTarif.scss';

interface AbroadDifferentTarifProps {
  packageDetailsList: PackageDetails[];
  packageData: AbroadPackageModel;
}

const detailsRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  return <>{filterRenderingByUse(packageDetail, packageData)}</>;
};

const filterRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  switch (packageData.type) {
    case PackageType.VoiceSmsData: {
      return (
        <>
          {phoneRenderingByUse(packageDetail, packageData)}
          {smsRenderingByUse(packageDetail, packageData)}
          {dataRenderingByUse(packageDetail, packageData)}
        </>
      );
    }
    case PackageType.VoiceAndSmsData: {
      return (
        <>
          {phoneAndSmsRenderingByUse(packageDetail, packageData)}
          {dataRenderingByUse(packageDetail, packageData)}
        </>
      );
    }
    case PackageType.VoiceAndSms: {
      return <>{phoneAndSmsRenderingByUse(packageDetail, packageData)}</>;
    }
    case PackageType.VoiceSms: {
      return (
        <>
          {phoneRenderingByUse(packageDetail, packageData)}
          {smsRenderingByUse(packageDetail, packageData)}
        </>
      );
    }
    case PackageType.Data: {
      return <>{dataRenderingByUse(packageDetail, packageData)}</>;
    }
    default:
      return null;
  }
};

const dataRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  const dataDisplay = getDataUsageDisplay(details?.data);
  return (
    <div className='AbroadDifferentTarif__content__container__price'>
      <span>{dataDisplay.value}</span>
      <span>{dataDisplay.unit}</span> ב-{shekelOrAgourot(details.data.priceByUsage)}
      {!(
        packageData?.steppedPerDay === true && packageData?.type.toLowerCase() === "data"
        ) && (
          <>
            ב - {shekelOrAgourot(details.data.priceByUsage)}
            {details.data.unit === UnitMeasureCodeOptionsFeature.PerDay ? ' ליום' : ''}
          </>
        )}
    </div>
  );
};

const smsRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  return <div className='AbroadDifferentTarif__content__container__price'>{shekelOrAgourot(details.sms.priceByUsage)} להודעה</div>;
};

const phoneRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  return <div className='AbroadDifferentTarif__content__container__price'>{shekelOrAgourot(details.voice.priceByUsage)} לדקה</div>;
};

const phoneAndSmsRenderingByUse = (packageDetail: PackageDetails, packageData: AbroadPackageModel) => {
  const details = packageDetail;
  return <div className='AbroadDifferentTarif__content__container__price'>{shekelOrAgourot(details.voice.priceByUsage)} לדקה/הודעה</div>;
};

const shekelOrAgourot = (price: number) => {
  if (price >= 1)
    return (
      <>
        <span>{price}</span> ₪
      </>
    );
  else
    return (
      <>
        <span>{price * 100}</span> אג'
      </>
    );
};

const AbroadDifferentTarif = ({packageDetailsList, packageData}: AbroadDifferentTarifProps) => {
  const renderPackageDetailsList = () =>
    packageDetailsList?.map((x, i) => (
      <div className='AbroadDifferentTarif__content__container'>
        <div className='AbroadDifferentTarif__content__container__state'>
          {x.countrySupportedList.map((y) => y.countryHebName).join(`, `)}
        </div>
        <>{detailsRenderingByUse(x, packageData)}</>
      </div>
    ));
  return (
    <div className={isMobile ? 'AbroadDifferentTarif isMobile' : 'AbroadDifferentTarif'}>
      <div className='AbroadDifferentTarif__title'>תעריפים למדינות שבחרתם:</div>
      <div className='AbroadDifferentTarif__content'>{renderPackageDetailsList()}</div>
    </div>
  );
};

export default AbroadDifferentTarif;
